require('./campaigns.less');

class CampaignsController {
    campaigns;
    tableDefinition = {
        settings: {title: "Kampanjer", editFunction: (event, campaign)=> this.editCampaign(event, campaign), promise: null},
        columns:[
            {title:'', name: 'active', type:'boolean', cellClass:'width-of-bool-cell'},
            {title:'Kode', name: 'code'},
            {title:'Beskrivelse', name:'description'},
            {title:'Sortering', name:'sortNo', type:'number'}
        ]
    };

    constructor(private toastService, private Campaigns, private $filter, private $mdDialog){
    }

    $onInit() {
        this.getCampaigns();
    }

    getCampaigns () {
        this.tableDefinition.settings.promise = this.Campaigns.getCampaigns().$promise.then(
            (result) => {
                this.campaigns = result.map(x => {
                    x.active = x.status === 'ACTIVE';
                    return x;
                });
            }, (error) => {
                this.toastService.parseError(error);
            }
        )
    };

    editCampaign (ev, campaign){
        this.$mdDialog.show({
            template: '<campaigns-dialog active-campaign-for-edit="c.activeCampaignForEdit"></campaigns-dialog>',
            targetEvent: ev,
            clickOutsideToClose: false,
            controllerAs:'c',
            controller: <any>[ function () {
                this.activeCampaignForEdit = campaign;
            }],
        }).then((msg) => {
            if(msg==='success'){
                this.getCampaigns();
            }
        });
    };

    addCampaign (ev){
        this.$mdDialog.show({
            template: '<campaigns-dialog></campaigns-dialog>',
            targetEvent: ev,
            clickOutsideToClose: false
        }).then((msg) => {
            if(msg==='success'){
                this.getCampaigns();
            }
        });

    }
}

class CampaignsOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "rkcCampaignsController";
    public template: any = require('./campaigns.html');
}

rkcApp.controller("rkcCampaignsController", ['toastService', 'Campaigns', '$filter', '$mdDialog', function( toastService, Campaigns, $filter, $mdDialog){
    return new CampaignsController(toastService, Campaigns, $filter, $mdDialog);
}])
    .component("rkcCampaigns", new CampaignsOptions());


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/campaigns/campaigns.ts
 **/